// extracted by mini-css-extract-plugin
module.exports = {"dataTableFormat":"styles_dataTableFormat__3KvW4","formSpace":"styles_formSpace__2QWRX"};